/** Llamadas HTTP del feature empresa: configuración del comité. */
import { apiPostBlob, apiRequest } from "../../lib/api";

export interface CicloConfig {
  dia_lecturas_inicio: number;
  dia_cierre_inicio: number;
  dia_emision_inicio: number;
  dia_cobranza_inicio: number;
  dia_morosidad_inicio: number;
}

export function fetchCicloConfig(): Promise<CicloConfig> {
  return apiRequest<CicloConfig>("/api/v1/empresa/configuracion-ciclo");
}

export function actualizarCicloConfig(
  payload: CicloConfig,
): Promise<CicloConfig> {
  return apiRequest<CicloConfig>("/api/v1/empresa/configuracion-ciclo", {
    method: "PATCH",
    body: payload,
  });
}

// ────────────────────────────────────────────────────────────────────
// Configuración general del comité (datos institucionales, banco,
// atención, boleta, SISS).
// ────────────────────────────────────────────────────────────────────

export type Segmento = "Mayor" | "Mediano" | "Menor";

export interface EmpresaConfiguracion {
  id: number;
  nombre: string;
  rut: string;
  email: string;

  direccion: string | null;
  telefono: string | null;
  telefono_emergencia: string | null;
  sitio_web: string | null;
  giro: string | null;

  logo_url: string | null;

  banco_nombre: string | null;
  tipo_cuenta: string | null;
  banco_cuenta: string | null;
  nombre_titular_cuenta: string | null;
  rut_titular_cuenta: string | null;

  horario_atencion: string | null;
  correo_reclamos: string | null;

  texto_resolucion_sii: string | null;
  mensaje_boleta: string | null;
  monto_multa_inasistencia: number | null;
  tasa_interes_mora_anual_pct: number;
  dias_vencimiento_boleta: number;
  /** Cargo por corte / reposición (CLP) que pre-llena la orden de corte. */
  cargo_corte: number;
  cargo_reposicion: number;
  /** Aporte que paga quien se incorpora como socio (0 = el comité no cobra). */
  cuota_incorporacion: number;
  /** Paquete por conexión nueva (instalación + medidor + materiales). */
  cargo_conexion: number;
  aviso_corte_en_boleta: boolean;
  aviso_corte_min_boletas: number;
  aviso_corte_texto: string | null;

  segmento: Segmento;
  anio_construccion_sistema: number | null;
}

export type EmpresaConfiguracionUpdate = Partial<
  Omit<EmpresaConfiguracion, "id" | "rut" | "email">
>;

export function fetchEmpresaConfiguracion(): Promise<EmpresaConfiguracion> {
  return apiRequest<EmpresaConfiguracion>("/api/v1/empresa/configuracion");
}

export function actualizarEmpresaConfiguracion(
  payload: EmpresaConfiguracionUpdate,
): Promise<EmpresaConfiguracion> {
  return apiRequest<EmpresaConfiguracion>("/api/v1/empresa/configuracion", {
    method: "PATCH",
    body: payload,
  });
}

// Preview en vivo del PDF de boleta — recibe los campos editables del form
// (sin guardar) + un escenario, devuelve el PDF como Blob para mostrar en
// un iframe vía URL.createObjectURL.

export type BoletaPreviewEscenario =
  | "normal"
  | "con_subsidio"
  | "con_saldo"
  | "con_corte"
  | "completo";

export interface BoletaPreviewRequest {
  escenario: BoletaPreviewEscenario;
  horario_atencion?: string | null;
  texto_resolucion_sii?: string | null;
  mensaje_boleta?: string | null;
  correo_reclamos?: string | null;
  banco_nombre?: string | null;
  tipo_cuenta?: string | null;
  banco_cuenta?: string | null;
  nombre_titular_cuenta?: string | null;
  aviso_corte?: string | null;
  rut_titular_cuenta?: string | null;
}

export function fetchBoletaPreview(
  payload: BoletaPreviewRequest,
  signal?: AbortSignal,
): Promise<Blob> {
  return apiPostBlob(
    "/api/v1/empresa/configuracion/boleta-preview.pdf",
    payload,
    signal,
  );
}
